import { render, staticRenderFns } from "./AboutUsImageSection.vue?vue&type=template&id=081500da&"
import script from "./AboutUsImageSection.vue?vue&type=script&lang=js&"
export * from "./AboutUsImageSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsImageSection.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports